import React, {useCallback} from 'react'
import {defineStyles, useThemedStyles} from './styles/style'

import {hexToRgb} from 'notability-services-common-universal'
import {useGLTranslation} from './hooks'

interface Props {
  collapsedHeight: number
  text: React.ReactNode
}

export function CollapsibleContainer({collapsedHeight, text}: Props) {
  const [isCollapsed, setCollapsed] = React.useState(true)
  const [forceFullView, setForceFullView] = React.useState(false)
  const s = useThemedStyles(styles)

  const {t} = useGLTranslation()

  const refCallback = useCallback((shortSize: HTMLDivElement | null) => {
    const currentHeight = shortSize?.clientHeight ?? 0
    const fullHeight = shortSize?.scrollHeight ?? -1
    setCollapsed(currentHeight > 0 && currentHeight < fullHeight)
  }, [])

  return (
    <div style={s.container}>
      <div style={isCollapsed && !forceFullView ? s.containerShort(collapsedHeight) : undefined} ref={refCallback}>
        {text}
        {isCollapsed && !forceFullView ? (
          <div style={s.seeMore} onClick={() => setForceFullView(true)}>
            {t('more')}
          </div>
        ) : null}
      </div>
    </div>
  )
}

const styles = defineStyles((theme) => ({
  container: {
    position: 'relative'
  },

  containerShort: (height: number) => ({
    display: 'block',
    position: 'relative',
    overflow: 'hidden',
    height: `${height}px`
  }),

  seeMore: {
    position: 'absolute',
    bottom: 0,
    paddingTop: '12px',
    width: '100%',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: theme.core.f2,
    backgroundImage: `linear-gradient(${hexToRgb(theme.core.b1, 0)}, ${theme.core.b1} 30%)`
  }
}))
